module.exports = __webpack_public_path__ + "media/images/icons/campus-icon-dfcae991ce00462b9e3ef90c38e7dad5.svg";